export class JobPrototyp {
  public name:string = null
  public partner_id:Array<any> = [
    {'model':'res.partner',
    'name': 'partner',
    'main_field': 'partner_id',
    'fields': ['street', 'zip', 'phone', 'city', 'country_id']}]
  public description:string = null
  public partner_phone:string = null
  public partner_info: string = null
  public state_name:string = null
  public state_descr:string = null
  public reservierplatz:string = null
  public type:string = null
  public monteur_id:Array<any> = []
  public date_planned:string = null
  public kdienst_1anfahrt:string = null
  public kdienst_2anfahrt:string = null
  public entfernung:string = null
  public orderline_ids:Array<any> = [
    {'model': 'rcs.kdienst.auftrag.line',
    'name': 'orderline',
    'main_field': 'orderline_ids',
    'fields': ['product_id', 'qty', 'product_uom', 'sequence', 'stock_qty', 'qty_real', 'route', 'state', 'create_uid']}]
  public schaetzline_ids:Array<any> = [
    {'model': 'rcs.kdienst.auftrag.schaetzzeit',
    'name': 'schaetzline',
    'main_field': 'schaetzline_ids',
    'fields': ['id', 'name', 'description', 'dauer', 'order_id', 'state']}]
  public analyze_note:string = null
  public workline_ids:Array<any> = [
    {'model':
    'rcs.kdienst.auftrag.zeit',
    'name': 'workline',
    'main_field': 'workline_ids',
    'fields': ['name', 'description', 'monteur_id', 'von', 'bis', 'dauer', 'state']}]
  public dicht_pruef:string = null
  public funktion_pruef:string = null
  public finish_notes:string = null
  public signature:string = null
  public abholbuchung: any = null
  public write_date: any = null

  constructor(){}

  // Liefert alle Attribute des Prototypen
  public get_attributs(test):Array<string>{
    let prototyp = new JobPrototyp();
    let keys = Object.keys(prototyp);
    return keys;
  }

  // Liefert alle Subobjektdefinition
  public get_sub_object_definition(){
    let sub_object_fields = [];
    let prototyp = new JobPrototyp();
    let keys = Object.keys(prototyp);
    for (let key of keys){
      if (prototyp[key] !== null && prototyp[key].length !== 0){
        sub_object_fields.push(prototyp[key][0]);
      }
    }
    return sub_object_fields;
  }
}



// WEBPACK FOOTER //
// ./src/assets/shared/job.object.ts